export enum LoadingStyle {
	TRANSPARENT = 'TRANSPARENT',
	OPAQUE = 'OPAQUE'
}

export interface LoadingState {
	isShowing: boolean,
	style: LoadingStyle
}
